import { Button, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { isNil } from "lodash";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarLoader } from "react-spinners";
import { CategoryAutocomplete, CategoryAutocompleteDto } from "../categories/autocomplete/CategoryAutocomplete";
import { SeasonAutocomplete, SeasonAutocompleteDto } from "../season/autocomplete/SeasonAutocomplete";
import { SubCategoryAutocomplete, SubCategoryAutocompleteDto } from "../subCategories/autocomplete/SubCategoryAutocomplete";
import { GenerateSeedDto, useMutateGenerateSeed } from "./query/GeneratorSeedQuery";




const SeedGeneratorScreen = () => {

    let [category, setCategory] = useState<CategoryAutocompleteDto | null>(null);
    let [subCategory, setSubCategory] = useState<SubCategoryAutocompleteDto | null>(null);
    let [season, setSeason] = useState<SeasonAutocompleteDto | null>(null);
    let [downloadZpf, setDownloadZpf] = useState<boolean>(false);

    let generateSeed = useMutateGenerateSeed();

    let navigate = useNavigate();

    const onSubmit = async () => {

        if (isNil(season))
            return;

        let result: GenerateSeedDto = {
            seasonId: season.id.toString(),
            downloadZpf: downloadZpf
        }

        let seedId = await generateSeed.mutateAsync(result)

        navigate("/ootr/generator/seed/" + seedId)
    }

    return <Grid>
        <CategoryAutocomplete label="OoT Category" onChange={(e) => { setCategory(e); setSubCategory(null); setSeason(null) }} selection={category} />
        <SubCategoryAutocomplete label="Sub Category / Tournament" onChange={(e) => { setSubCategory(e); setSeason(null) }} selection={subCategory} categoryId={category?.id} />
        <SeasonAutocomplete label="Seasons" onChange={(e) => { setSeason(e) }} selection={season} subCategoryId={subCategory?.id} />
        <FormControlLabel control={<Checkbox checked={downloadZpf} onChange={(e) => setDownloadZpf(!downloadZpf)} />} label="Download Patch File after Generation" />
        <Button onClick={async () => await onSubmit()} disabled={generateSeed.isLoading}>Generate Seed</Button>
        {generateSeed.isLoading && <BarLoader color="green" />}
    </Grid>
}

export default SeedGeneratorScreen;
